import { useEffect, useState } from 'react'
import firebase, { db } from 'utils/firebase'
import { api, firebaseCollections as collections, adjustmentStatuses, itemStatuses, rentalStatuses } from 'utils/constants'
import { useData } from 'utils/context'
import { instance as axios } from 'utils/api/axios/firebase'
import { makeSets, getStoreBySquareId } from 'utils/helpers'
import * as Sentry from "@sentry/nextjs";

const useStartRental = () => {
  const { user, rental, currentStore, dispatchNotification } = useData()
  const sets = makeSets({ data: rental?.items });
  const [startCount, setStart] = useState(0)
  const [loading, setLoading] = useState(false);
  const store = currentStore ?? getStoreBySquareId(user?.stores, rental?.originStoreId) ?? user?.defaultStore
  const [startStore, setStartStore] = useState(store)
  const [error, setError] = useState('');

  const start = () => setStart(count => count + 1)
  const handleStart = async () => {
    let startTag = { action: 'start rental' }
    let dueDate = sets[0] ?  sets[0]?.dueDate : null
    setLoading(true)
    let batch = db.batch();
    try {
    let inventoryAjusment = []
  
    let rentalRef = db.collection(collections.rentals).doc(rental?.id)
    let parsedDate
    if (Date.parse(dueDate)) {
      parsedDate = new Date(dueDate)
    } else {
      let today = new Date()
      parsedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)
    }
    batch.update(rentalRef, {
      status: rentalStatuses.open,
      dueDate: firebase.firestore.Timestamp.fromDate(parsedDate),
      storePickupsTracking: [],
      startDate: firebase.firestore.Timestamp.now(),
      startStore: { id: startStore.id, name: startStore.name },
      rentalStartedBy: { uid: user?.uid ?? "", name: user?.name ?? "", email: user?.email ?? '' }
    })
  
    rental.items.forEach(item => {
      if (item?.catalogObjectId) {
        inventoryAjusment.push({
          catalogObjectId: item?.catalogObjectId ?? "",
          locationId: startStore.id,
          quantity: 1,
          type: adjustmentStatuses.pickup
        })
      }
      let itemRef = rentalRef.collection(collections.items).doc(item?.id)
      batch.update(itemRef, {
        returnedStatus: itemStatuses.outWithCustomer
      })
    })
      await batch.commit()
      if (inventoryAjusment.length > 0) await axios.post(api.batchInventory, { adjustments: inventoryAjusment })
      dispatchNotification({ message: 'Started Rental successfully', type: 'success' })
      setError('')
    } catch (e) {
      dispatchNotification({ message: 'An error occured', type: 'error' })
      Sentry.captureException(e, { tags: startTag, contexts: { rentalId: rental?.id, ticketNumber: rental?.ticketNumber } });
      console.log(e)
      setError(e)
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (startCount > 0){
      handleStart()
    }
  }, [startCount])
  return { loading, error, start, setError, startStore, setStartStore }
}


export default useStartRental
